import { useEffect } from 'react';
var useDoko = function useDoko(_ref) {
  var env = _ref.env,
    title = _ref.title,
    subtitle = _ref.subtitle,
    facts = _ref.facts,
    report = _ref.report;
  useEffect(function () {
    if (env) {
      var metaEnv = document.createElement('meta');
      metaEnv.setAttribute('name', 'doko:environment');
      metaEnv.setAttribute('content', env);
      document.head.appendChild(metaEnv);
    }
    if (title) {
      var metaTitle = document.createElement('meta');
      metaTitle.setAttribute('name', 'doko:title');
      metaTitle.setAttribute('content', title);
      document.head.appendChild(metaTitle);
    }
    if (subtitle) {
      var metaSubtitle = document.createElement('meta');
      metaSubtitle.setAttribute('name', 'doko:subtitle');
      metaSubtitle.setAttribute('content', subtitle);
      document.head.appendChild(metaSubtitle);
    }
    if (facts && facts.length > 0) {
      facts.forEach(function (fact) {
        var metaFact = document.createElement('meta');
        metaFact.setAttribute('name', 'doko:fact');
        metaFact.setAttribute('content', fact.key + "|" + fact.value);
        document.head.appendChild(metaFact);
      });
    }
    if (report) {
      // Validate url
      try {
        new URL(report);
      } catch (e) {
        console.warn("DOKO: Incorrect Report format. Report should be a valid url, beginning with http(s) but found '" + report + "'");
      }
      var metaReport = document.createElement('meta');
      metaReport.setAttribute('name', 'doko:report');
      metaReport.setAttribute('content', report);
      document.head.appendChild(metaReport);
    }
  }, [env, facts, report, subtitle, title]);
};
export default useDoko;